module.exports = __webpack_public_path__ + "img/border_bl.54aac1ed.svg";